import qs from 'qs'

import { HttpService, HttpServiceResponse } from '../shared'
import {
  CRAActions,
  CRARequestServerData,
  CRAStatusServerData,
  CRAProfileServerData,
  AddCRAClientServerData,
} from './cra.types'

export class CRAProvider {
  constructor(private http: HttpService, private baseUrl: string) {}

  private get url(): string {
    return `${this.baseUrl}/sda_cra_api.php`
  }

  public get(
    pin: string,
    idDocNo: number,
    birthYear: number,
    subContractId: number,
  ): Promise<HttpServiceResponse<CRARequestServerData>> {
    const queryString = qs.stringify({
      action: CRAActions.New,
      PersonalNo: pin,
      IDDocNo: idDocNo,
      BirthYear: birthYear,
      SubContractID: subContractId,
    })

    return this.http.post(`${this.url}?${queryString}`)
  }

  public getStatus(id: number): Promise<HttpServiceResponse<CRAStatusServerData>> {
    return this.http.post(`${this.url}?action=${CRAActions.ViewStatus}&Ident=${id}`)
  }

  public getData(id: number): Promise<HttpServiceResponse<CRAProfileServerData>> {
    return this.http.post(`${this.url}?action=${CRAActions.ViewData}&CRARequestID=${id}`)
  }

  public printCRA(action: string): Promise<HttpServiceResponse<unknown[]>> {
    return this.http.post(`${this.url}?action=${action}`)
  }

  public add(
    pin: string,
    requestId: number,
    requestHash: string,
    clientId: number,
    clientHash: string,
  ): Promise<HttpServiceResponse<AddCRAClientServerData>> {
    const queryString = qs.stringify({
      action: CRAActions.AddClient,
      PersonalNo: pin,
      CRARequestID: requestId,
      HashSum_CRARequestID_: requestHash,
      ClientID: clientId,
      HashSum_ClientID_: clientHash,
    })

    return this.http.post(`${this.url}?${queryString}`)
  }
}
